(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["auralith-night-sky"] && !Shopify.designMode) return;
  try {
    (() => {
    const canvas = document.querySelector('.auralith-night-sky__canvas');
    if (!canvas) return;

    const context = canvas.getContext('2d', { alpha: true });
    if (!context) return;

    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let stars = [];
    let width = 0;
    let height = 0;
    let animationFrame = 0;
    let lastFrame = 0;

    const createStars = () => {
      const mobile = width < 750;
      const count = mobile ? 28 : Math.min(68, Math.round((width * height) / 26000));
      stars = Array.from({ length: count }, () => ({
        x: Math.random() * width,
        y: Math.random() * height,
        radius: Math.random() * 0.8 + 0.28,
        alpha: Math.random() * 0.38 + 0.24,
        phase: Math.random() * Math.PI * 2,
        speed: Math.random() * 0.0016 + 0.00045,
        drift: Math.random() * 0.007 + 0.002,
        gold: Math.random() > 0.78
      }));
    };

    const resize = () => {
      const ratio = Math.min(window.devicePixelRatio || 1, 1.5);
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = Math.round(width * ratio);
      canvas.height = Math.round(height * ratio);
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
      createStars();
      draw(performance.now(), true);
    };

    const draw = (time, still = false) => {
      context.clearRect(0, 0, width, height);

      for (const star of stars) {
        if (!still) {
          star.y += star.drift;
          if (star.y > height + 3) star.y = -3;
        }

        const twinkle = motionQuery.matches ? star.alpha : star.alpha * (0.58 + 0.42 * Math.sin(time * star.speed + star.phase));
        const color = star.gold ? `rgba(218, 185, 112, ${twinkle})` : `rgba(242, 239, 255, ${twinkle})`;

        context.beginPath();
        context.arc(star.x, star.y, star.radius, 0, Math.PI * 2);
        context.fillStyle = color;
        context.shadowColor = color;
        context.shadowBlur = star.radius > 1 ? 5 : 2;
        context.fill();
      }

      context.shadowBlur = 0;
    };

    const animate = (time) => {
      if (time - lastFrame >= 33) {
        draw(time);
        lastFrame = time;
      }
      animationFrame = window.requestAnimationFrame(animate);
    };

    const updateMotion = () => {
      window.cancelAnimationFrame(animationFrame);
      if (motionQuery.matches) {
        draw(performance.now(), true);
      } else {
        animationFrame = window.requestAnimationFrame(animate);
      }
    };

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(resize, 150);
    }, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        window.cancelAnimationFrame(animationFrame);
      } else {
        updateMotion();
      }
    });

    motionQuery.addEventListener('change', updateMotion);
    resize();
    updateMotion();
  })();
  } catch(e) { console.error(e); }
})();

})();
